import React from 'react'
import Liberyus from '../../components/general/liberyus'
import ContactBanner from './contact-banner'
import ContactForm from './contact-form'

const ContactPage = () => {
    return (
        <Liberyus>
            <div className='contact-page'>
                <ContactBanner />
                <ContactForm />
            </div>
        </Liberyus>
    )
}

export default ContactPage
